import { createContext, useContext, useEffect, useState } from "react";

const OfflineContext = createContext({ isOffline: false, showBackOnline: false });

export function OfflineProvider({ children }) {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [showBackOnline, setShowBackOnline] = useState(false);

  useEffect(() => {
    const handleOffline = () => setIsOffline(true);
    const handleOnline = () => {
      setIsOffline(false);
      setShowBackOnline(true);
      setTimeout(() => setShowBackOnline(false), 3000);
    };
    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);
    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  return (
    <OfflineContext.Provider value={{ isOffline, showBackOnline }}>
      {children}
    </OfflineContext.Provider>
  );
}

export function useOffline() {
  return useContext(OfflineContext);
}

export function OfflineBanner() {
  const { isOffline, showBackOnline } = useOffline();
  if (isOffline) {
    return (
      <div className="offline-banner" role="alert">
        <span>&#9888;&#65039; You're offline — some features may not work until you reconnect</span>
      </div>
    );
  }
  if (showBackOnline) {
    return <div className="online-banner" role="status">Back online</div>;
  }
  return null;
}
